import axios from "axios";
import url from "../urls";

export default {
  //post
  getAudioText(context, data) {
    return new Promise((resolve, reject) => {
      let getUrl = url.GetAudioText;
      axios
        .post(getUrl, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },

  // 云知声口语评测接口
  evaluatePronunciation(context, data) {
    return new Promise((resolve, reject) => {
      const {
        audioBlob,
        text,
        audioFormat = 'wav',
        mode = 'E',
        appkey,
        deviceId,
        isChinese = false,
        scoreCoefficient,
        repeat
      } = data;

      // 生成 session-id (UUID)
      const sessionId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });

      // 根据语言选择接口地址
      const baseUrl = isChinese 
        ? 'https://cn-edu.hivoice.cn/eval'
        : 'https://edu.hivoice.cn/eval';
      const evalUrl = `${baseUrl}/${audioFormat}`;

      // 创建 FormData
      const formData = new FormData();
      formData.append('text', text);
      formData.append('mode', mode);
      formData.append('voice', audioBlob);

      // 设置请求头
      const headers = {
        'session-id': sessionId,
        'appkey': appkey || 'd2vi6a6plyspmhigxtm2p2yqimjkyvxs5tyhnhy4@bfb79ecc0bb083a0d974e475e95983c4',
        'Wrap-Create-Time': 'true'
      };

      if (deviceId) {
        headers['device-id'] = deviceId;
      }

      if (isChinese) {
        headers['X-EngineType'] = 'oral.zh_CH';
      }

      if (scoreCoefficient) {
        headers['score-coefficient'] = scoreCoefficient.toString();
      }

      if (repeat !== undefined) {
        headers['repeat'] = repeat.toString();
      }

      axios
        .post(evalUrl, formData, {
          headers: headers,
          timeout: 30000 // 30秒超时
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.error('云知声口语评测错误:', error);
          reject(error);
        });
    });
  },
};
